import React, { useState } from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import { TablePlantillas } from './components/TablePlantillas';
import { FormPlantillas } from './components/FormPlantillas';
import { BreadCrumbsAndTitle } from '../../../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../../../commons/texts';
import { mtDividerUpTable } from '../../../../commons';

export const PlantillasRespuestas = () => {
  const [showForm, setShowForm] = useState(false);
  const [templateToEdit, setTemplateToEdit] = useState<any | null>(null);

  const handleCreate = () => {
    setTemplateToEdit(null);
    setShowForm(true);
  };

  const handleEdit = (template: any) => {
    setTemplateToEdit(template);
    setShowForm(true);
  };

  const handleCancel = () => {
    setShowForm(false);
    setTemplateToEdit(null);
  };

  return (
    <Box sx={{ p: 3, maxWidth: 1400, margin: '0 auto' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Box>
                <BreadCrumbsAndTitle
                    title="Plantillas de Respuestas" 
                    mainModule="Reputación Online" 
                    parent="Configuraciones"
                    action="Plantillas de Respuestas" 
                    icon="FormatListBulleted"
                />
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.plantillasRespuestas} /> 
                </Typography> 
            </Box>
            
            <Button 
                variant="contained" 
                startIcon={<AddIcon />} 
                onClick={handleCreate}
                sx={{ 
                    bgcolor: '#4A148C', 
                    '&:hover': { bgcolor: '#380b6b' },
                    borderRadius: 1.5,
                    textTransform: 'none',
                    fontWeight: 700,
                    px: 3,
                    py: 1
                }}
            >
                Nueva Plantilla
            </Button>
        </Box>

        <Divider sx={{ marginBottom: mtDividerUpTable }}/>
        
        <TablePlantillas 
            onEdit={handleEdit} 
        />

        <FormPlantillas 
            open={showForm}
            handleClose={handleCancel}
            templateData={templateToEdit} 
        />
    </Box>
  );
};
